import React, { useState } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { useFormikContext } from 'formik';
import enTranslations from '../../__i18n__/en';
import frTranslations from '../../__i18n__/fr';
import useStyles from './FindingFilters.styles';
import MultipleSelectField from '../../../common/components/fields/MultipleSelectField';
import { mapClientCategoriesToSelectOptions, mapEnumToSelectOptions } from '../../../common/formatters/arrayFormatter';
import { allFindingTypeFiltersEnum, generalFindingTypeFiltersEnum } from '../../models/findingTypeFilterEnum';
import CheckboxField from '../../../common/components/fields/CheckboxField';
import TextField from '../../../common/components/fields/TextField';
import { ClientCategoryShape } from '../../../client/models/ClientCategory';
import { adminOnlyLabelFiltersEnum } from '../../models/findingLabelFilterEnum';

const FindingFilters = ({ showOnlyClientFilters, clientCategories }) => {
  const classes = useStyles();

  const { submitForm, values } = useFormikContext();
  const [prevFindingIdFilterValue, setPreviousFindingIdFilterValue] = useState(values.exactFindingId);

  const handleIdFieldBlur = ({ target }) => {
    if (+target.value !== +prevFindingIdFilterValue) submitForm();
    setPreviousFindingIdFilterValue(values.exactFindingId);
  };

  const combinedCategories = [...clientCategories];

  if (!showOnlyClientFilters) {
    const adminCategories = Object.keys(adminOnlyLabelFiltersEnum).map((key) => ({
      key: adminOnlyLabelFiltersEnum[key],
      labelEn: enTranslations.class?.[key],
      labelFr: frTranslations.class?.[key],
    }));

    combinedCategories.push(...adminCategories);
  }

  return (
    <div className={classes.filters}>
      <TextField
        className={classes.numberField}
        type="number"
        name="exactFindingId"
        label={i18n.t('patrol.finding.exactFindingId')}
        onBlur={handleIdFieldBlur}
      />
      <MultipleSelectField
        muiClasses={{ select: classes.select }}
        className={classes.selectField}
        onChange={submitForm}
        label={i18n.t('patrol.finding.class')}
        name="labelClasses"
        options={mapClientCategoriesToSelectOptions(combinedCategories)}
      />

      <MultipleSelectField
        muiClasses={{ select: classes.select }}
        className={classes.selectField}
        onChange={submitForm}
        label={i18n.t('patrol.finding.type')}
        name="typeClasses"
        options={mapEnumToSelectOptions(showOnlyClientFilters ? generalFindingTypeFiltersEnum : allFindingTypeFiltersEnum, {
          i18nResource: 'finding.type',
        })}
      />
      <CheckboxField name="hideRegularPassengerVehicles" label={i18n.t('patrol.finding.hidePassengerVehicles')} onChange={submitForm} />
    </div>
  );
};

FindingFilters.propTypes = {
  showOnlyClientFilters: PropTypes.bool.isRequired,
  clientCategories: PropTypes.arrayOf(ClientCategoryShape).isRequired,
};

FindingFilters.defaultProps = {};

export default FindingFilters;
